import { render, staticRenderFns } from "./reviewNotification.vue?vue&type=template&id=0536290c&scoped=true&"
import script from "./reviewNotification.vue?vue&type=script&lang=js&"
export * from "./reviewNotification.vue?vue&type=script&lang=js&"
import style0 from "./reviewNotification.vue?vue&type=style&index=0&id=0536290c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0536290c",
  null
  
)

export default component.exports